import React from 'react';

const SCSContexto = React.createContext<any>(null);

export { SCSContexto };
